module.exports = __webpack_public_path__ + "img/jft.0359f35f.png";